import HomeContainer from "./containers/HomeContainer";

export default [
    {
        path: "/",
        component: HomeContainer
    }
];
